// extracted by mini-css-extract-plugin
export default {"root":"buy_button__root__wAwHK","arrowUp":"buy_button__arrowUp__ENeUI","divider":"buy_button__divider__zvoAR","dropdownButton":"buy_button__dropdownButton__AgK8_"};